const PENDING_SHARE_TOKEN_KEY = "excalidraw-ms:pending-share-token";
const PENDING_SHARE_TOKEN_TTL_MS = 10 * 60 * 1000;

interface PendingShareToken {
  token: string;
  expiresAt: number;
}

export function captureShareToken(hash: string): string {
  const params = new URLSearchParams(hash.slice(1));
  if (params.has("ref") || params.has("token")) {
    clearPendingShareTokenValue();
    if (params.has("ref") && params.has("token")) return "";
    const reference = params.get("ref");
    return params.has("ref") ? (reference ? `ref:${reference}` : "") : (params.get("token") ?? "");
  }

  const pendingValue = window.sessionStorage.getItem(PENDING_SHARE_TOKEN_KEY);
  window.sessionStorage.removeItem(PENDING_SHARE_TOKEN_KEY);
  if (!pendingValue) return "";

  try {
    const pending = JSON.parse(pendingValue) as Partial<PendingShareToken>;
    const token =
      typeof pending.token === "string" &&
      typeof pending.expiresAt === "number" &&
      pending.expiresAt > Date.now()
        ? pending.token
        : "";
    if (token && window.location.pathname === "/shared") {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}${window.location.search}#token=${encodeURIComponent(token)}`,
      );
    }
    return token;
  } catch {
    return "";
  }
}

export function persistShareTokenForSignIn(shareToken: string): void {
  const pending: PendingShareToken = {
    token: shareToken,
    expiresAt: Date.now() + PENDING_SHARE_TOKEN_TTL_MS,
  };
  window.sessionStorage.setItem(PENDING_SHARE_TOKEN_KEY, JSON.stringify(pending));
}

export function clearPendingShareToken(): void {
  clearPendingShareTokenValue();
  if (window.location.pathname === "/shared") {
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }
}

function clearPendingShareTokenValue(): void {
  try {
    window.sessionStorage.removeItem(PENDING_SHARE_TOKEN_KEY);
  } catch {
    // Storage may be blocked; the caller can still handle the captured link.
  }
}
